import script from "./web-collection-list.vue?vue&type=script&setup=true&lang=js"
export * from "./web-collection-list.vue?vue&type=script&setup=true&lang=js"

import "./web-collection-list.vue?vue&type=style&index=0&id=1b5e2d7c&lang=scss"

const __exports__ = script;

export default __exports__